module.exports = __webpack_public_path__ + "img/active.64c62d8a.svg";